<template>
<div class="mt-4">
    <v-card class="mx-auto" max-width="400">
        <v-toolbar color="white" elevation="0" class="text-center">

            <v-row>

                <v-col class="d-flex justify-space-around">
                    <v-toolbar-title>ลืมรหัสผ่าน</v-toolbar-title>
                </v-col>

            </v-row>

        </v-toolbar>
        <v-divider></v-divider>

                <div class="pa-5 pb-0 html" v-if="page">
            <div v-html="page.html"  v-if="page.html" />
         </div>

        <v-card-text v-if="!formDisplay" class="text-center">
            <div v-if="!otp">
                <div v-if="msg" v-html="msg"></div>

                <InputMask mask="999 999-9999" v-model="data.phone" placeholder="" class="text-center"/>

              
                <div class="mt-2">**โปรดระบุหมายเลขมือถือที่ใช้ตอนสมัครสมาชิกค่ะ</div>

                <div class="text-center mt-3">
                    <v-btn color="blue darken-1" dark @click="checkUserPhone()">
                        ตกลง
                    </v-btn>
                </div>
            </div>

            <Otp v-if="otp" title="" :item="data" :sms="sms" :otp="otp" class="animate__animated animate__zoomIn" @reSend="reSend" @confirm="setForm" />
        </v-card-text>

        <v-card-text v-if="formDisplay">
            <FormForgotPasssword :member="data" />
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import FormForgotPasssword from '@/views/Member/FormForgotPasssword'
 
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Otp from '@/views/Member/Otp'
export default {

    components: {
 
        FormForgotPasssword,
        Otp
    },

      props: {

        page: null

    },

    data: () => ({
        telephone: null,
        group_id: null,
        otp: null, 
        complete: null,

        formDisplay: null,

        msg: null,

        sms: null,
        data: {
            phone: null
        },

        phoneRules: [
            v => !!v || 'โปรดระบุเบอร์มือถือด้วยค่ะ'
        ],

    }),

    computed: {

    },

    watch: {

    },
    methods: {

        setForm() {

            this.formDisplay = true

        },
 

        checkUserPhone() {
            this.msg = null;
            if (this.data.phone) {
                this.$FULL_LOADING = true

                const formData = this.$formData(
                    this.data
                );

                let url = "member/checkPhone";
                let $vm = this;
                this.$API
                    .post(url, this.formData(formData))
                    .then(function (res) {
                        $vm.checkApi(res);
                        $vm.$FULL_LOADING = null
                        if (!res.data.check) {
                            $vm.msg = res.data.msg
                        } else {
                            $vm.data = res.data.member
                           $vm.getOtp()
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            }

        },

        reSend() {
            this.getOtp(true)

        },

        getOtp(resend) {

            this.$FULL_LOADING = true

            if (resend) { //ส่งอีกครั้ง ใช้เลข Otp อันเดิม
                this.data.otp = this.otp
            }

            const formData = this.$formData(
                this.data
            );

            let url = "member/getOtp?type=forgotpassword";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    if (res.data.re == 'success') {
                        $vm.sendOtp(res.data.sms)
                        $vm.otp = res.data.otp
                        $vm.sms = res.data.sms 
                        $vm.data.sms_id = res.data.sms.sms_id
                        $vm.$FULL_LOADING = null

                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

    },
};
</script>
